import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;

	> #id-createOrder-button-card-paint {
		padding: 0.2rem;
		white-space: nowrap;
		max-width: 100%;
	}
`;

export const AreaIconVideo = styled.div``;
